import ExchangeCreditSummary from "@/components/articles-lists/exchange-credit-summary";
import { NewProductForExchangeCreditList } from "@/pages/(app)/returns/refund/page";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";
import useTranslation from "@babackapp/translations/use-translation";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import { Badge } from "@babackapp/ui/components/badge";

export default function ArticlesExchanged() {
  const t = useTranslation();
  const currentReturnRequest = useCurrentReturnRequest();

  if (!currentReturnRequest.exchange.newProductForExchangeCredit?.length) {
    return null;
  }

  return (
    <AccordionItem value="exchanged">
      <AccordionTrigger>
        <span>
          {t("returnDetail.confirmModal.titleNewOrder")}
          <Badge variant="success-outline" className="ml-2">
            {currentReturnRequest.exchange.newProductForExchangeCredit.length}
            {t("orderPortal.sumup.articles")}
          </Badge>
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <NewProductForExchangeCreditList
          items={currentReturnRequest.exchange.newProductForExchangeCredit}
          currency={currentReturnRequest.currency.customerCurrency}
        />
        <ExchangeCreditSummary returnRequest={currentReturnRequest} />
      </AccordionContent>
    </AccordionItem>
  );
}
